import React, { useEffect, useMemo, useState } from "react";
import classes from "./customForm.module.css";
import { useCustomForm } from "./useCustomForm";
import { Button, Spin } from "antd";
import OtherForm from "./otherFormView/otherForm";
import { Helmet } from "react-helmet";
import MainComponent from "../../components/MainComponent/mainComponent";

const CustomForm = props => {
    // [EMBED_LANG_SYNC] Keep embed form params in local state so we can switch form without page redirect.
    const [embedFormParams, setEmbedFormParams] = useState({
        fCode: props.fCode,
        mCode: props.mCode,
        fType: props.fType
    });

    useEffect(() => {
        setEmbedFormParams({
            fCode: props.fCode,
            mCode: props.mCode,
            fType: props.fType
        });
    }, [props.fCode, props.mCode, props.fType]);

    const customFormHookProps = {
        ...props,
        ...embedFormParams,
        onEmbedFormChange: (nextFormData) => {
            setEmbedFormParams(prev => ({
                ...prev,
                ...nextFormData
            }));
        }
    };

    const {
        isEmbed,
        customFormCode,
        currentMerchantCode,
        contextHolder,
        loading,
        customFormType,
        formData,
        custom_form,
        handleSubmitSurvey,
        showSubmitSuccess,
        handleSubmitCustomForm,
        handleAlertErrorMessage,
        otpLoading,
        canSendOtp,
        waitOtpSeconds,
        validateOtpResult,
        validateOtpLoading,
        handleStartSendOtp,
        handleChangeOTP,
        handleChangeEmail,
        allFieldValues,
        setAllFieldValues,
        formClientWidth,
        setFormClientWidth,
        htmlData,
        errorMessage,
        successMessage,
        languageOptions,
        selectedLanguageCode,
        showLanguageSelector,
        handleChangeLanguage,
        recaptcha
    } = useCustomForm(customFormHookProps);

    const FormContent = useMemo(()=>{
        return <>
            {contextHolder}
            {
                showSubmitSuccess ? <div className={classes.success_root}>
                    <div className={classes.success_container}>
                        <p className={classes.success_header_p}>Submit Success!</p>
                        <div className={classes.success_actions}>
                            <Button type="primary" onClick={()=>{
                                window.location.reload();
                            }}>
                                Back To Form
                            </Button>
                        </div>
                    </div>
                </div> : <Spin spinning={loading}>
                    {
                        formData ? <OtherForm 
                            isEmbed={isEmbed}
                            fCode={customFormCode}
                            cmCode={currentMerchantCode}
                            formData={formData}
                            custom_form={custom_form}
                            handleSubmit={handleSubmitCustomForm}
                            handleAlertError={handleAlertErrorMessage}
                            otpLoading={otpLoading}
                            canSendOtp={canSendOtp}
                            waitOtpSeconds={waitOtpSeconds}
                            validateOtpResult={validateOtpResult}
                            validateOtpLoading={validateOtpLoading}
                            handleStartSendOtp={handleStartSendOtp}
                            handleChangeOTP={handleChangeOTP}
                            handleChangeEmail={handleChangeEmail}
                            allFieldValues={allFieldValues}
                            setAllFieldValues={setAllFieldValues}
                            formClientWidth={formClientWidth}
                            setFormClientWidth={setFormClientWidth}
                            errorMessage={errorMessage}
                            successMessage={successMessage}
                            languageOptions={languageOptions}
                            selectedLanguageCode={selectedLanguageCode}
                            showLanguageSelector={showLanguageSelector}
                            handleChangeLanguage={handleChangeLanguage}
                            recaptcha={recaptcha}
                        /> : loading ? null : <div className={classes.empty_root}>
                            Invalid {customFormType === 'survey' ? 'Survey' : 'Form'}
                        </div>
                    }
                </Spin>
            }
        </>
    }, [allFieldValues, canSendOtp, contextHolder, customFormType, custom_form, errorMessage, formClientWidth, formData, 
        handleAlertErrorMessage, handleChangeEmail, handleChangeOTP, handleStartSendOtp, handleSubmitCustomForm, 
        isEmbed, loading, otpLoading, setAllFieldValues, setFormClientWidth, showSubmitSuccess, successMessage, 
        validateOtpLoading, validateOtpResult, waitOtpSeconds, customFormCode, currentMerchantCode, 
        handleChangeLanguage, languageOptions, selectedLanguageCode, showLanguageSelector, recaptcha])
    
    function isIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true; // 跨域访问报错时，也说明在 iframe 中
        }
    }

    return <>
        <Helmet >
            <title>{htmlData.title || 'Custom Form'}</title>
            <meta name="description" content={htmlData.title || 'Custom Form'} />
            <link rel="icon" href={htmlData.favicon || 'https://www.gaxas.ai/api/media/file/favicon-1.svg'}/>
        </Helmet>
        
        <MainComponent children={FormContent} isIframe={isIframe() || isEmbed} bgColor={formData?.root ? (formData.root.data?.backdropColor || '#F5F5F5') : null}/>
    </>
}

export default CustomForm;
